import { XIcon } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "web-design-system";

const VideoDialog = ({
  open,
  setOpen,
  embedUrl,
  title,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  embedUrl: string;
  title: string;
}) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="w-[80vw] max-w-4xl gap-0 border-0 bg-black p-0">
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <XIcon
          className="absolute right-5 -top-6 z-10 -translate-y-1/2 translate-x-1/2 size-8 text-white cursor-pointer"
          onClick={() => setOpen(false)}
        />

        {embedUrl ? (
          <div className="relative aspect-video w-full overflow-hidden rounded-lg overflow-hidden">
            {open ? (
              <iframe
                src={embedUrl}
                title={title}
                className="absolute inset-0 size-full border-0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            ) : null}
          </div>
        ) : (
          <p className="p-6 text-sm text-muted-foreground rounded-lg overflow-hidden">
            This tutorial video is unavailable.
          </p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default VideoDialog;
